import { useState } from "react";
import Logo from "../../../assets/logo.svg";
import Teleport from "../../Custom/Teleport";
import "./NavBar.css";
import { Button, PopoverPaper } from "@mui/material";
const NavBar = () => {
  const [hamburger, setHamburger] = useState("hamburger");

  function launchLogin() {
    window.open("/login", "_self");
  }

  function launchRegister() {
    window.open("/register", "_self");
  }

  function toggleMenu() {
    if (hamburger === "hamburger") {
      setHamburger("hamburger open");
    } else {
      setHamburger("hamburger");
    }
  }

  const navigations = [
    {
      name: "Home",
      id: "#home",
    },
    {
      name: "Features",
      id: "#features",
    },
    {
      name: "Services",
      id: "#services",
    },
    {
      name: "Contact",
      id: "mailto:reny.reyes@hotmail.com",
    },
  ];
  return (
    <nav id="landing-nav">
      <ul>
        <li>
          <img src={Logo} alt="Assessive Logo" />
        </li>
        <li className="desktop">
          <div className="link-items">
            {navigations.map((link) => {
              return (
                <a
                  href={link.id}
                  className="no-decor-link nav-link"
                  key={link.id}
                >
                  {link.name}
                </a>
              );
            })}
          </div>
        </li>
        <li className="button-items desktop">
          <Button
            size="small"
            className="py-1 px-3"
            sx={{
              "&:hover": {
                backgroundColor: "transparent",
                color: "var(--text)",
              },
            }}
            onClick={launchLogin}
          >
            Login
          </Button>
          <Button
            size="small"
            className="py-1 px-3"
            style={{
              background: "var(--blueGradient)",
            }}
            variant="contained"
            disableElevation
            onClick={launchRegister}
          >
            Sign Up
          </Button>
        </li>
        <li className="mobile-menu">
          <button
            onClick={() => toggleMenu()}
            id="menu-btn-mobile-landing"
            className={hamburger}
            title="Toggle Menu"
            aria-labelledby="menu-btn-mobile-landing"
          >
            <span className="hamburger-top"></span>
            <span className="hamburger-middle"></span>
            <span className="hamburger-bottom"></span>
          </button>
          <Teleport>
            <PopoverPaper
              className="mobile-menu"
              hidden={hamburger === "hamburger"}
              square={false}
              sx={{ boxShadow: "var(--box-shadow)", position: "fixed" }}
              onClose={() => toggleMenu("mobile")}
            >
              <ul>
                {navigations.map((link) => {
                  return (
                    <li key={link.id}>
                      <a
                        href={link.id}
                        className="no-decor-link nav-link"
                        key={link.id}
                      >
                        {link.name}
                      </a>
                    </li>
                  );
                })}
                <li className="no-border">
                  <Button
                    size="small"
                    className="py-1 px-3"
                    sx={{
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "var(--text)",
                      },
                      fontSize: "12px",
                    }}
                    onClick={launchLogin}
                  >
                    Login
                  </Button>
                  <Button
                    size="small"
                    className="py-1 px-3"
                    style={{
                      background: "var(--blueGradient)",
                      fontSize: "12px",
                    }}
                    variant="contained"
                    disableElevation
                    onClick={launchRegister}
                  >
                    Sign Up
                  </Button>
                </li>
              </ul>
            </PopoverPaper>
          </Teleport>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
